import { HiX } from "react-icons/hi";
import { createPortal } from "react-dom";
import {
    cloneElement,
    createContext,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";

// import useOutSideClick from "../hooks/useClickOutside";

const ModalContext = createContext();

function Modal({ children }) {
    const [openName, setOpenName] = useState("");

    const close = () => setOpenName("");
    const open = (name) => setOpenName(name);

    return (
        <ModalContext.Provider value={{ openName, close, open }}>
            {children}
        </ModalContext.Provider>
    );
}

function Open({ children, opens: openWindowName }) {
    const { open } = useContext(ModalContext);

    return cloneElement(children, { onClick: () => open(openWindowName) });
}
function Window({ children, name, enableOutsideClick = false }) {
    const { openName, close } = useContext(ModalContext);
    const modalRef = useRef(null);

    useEffect(() => {
        if (name === openName) {
            // Disable background scrolling when the modal is open
            document.body.style.overflow = "hidden";
        } else {
            // Enable background scrolling when the modal is closed
            document.body.style.overflow = "unset";
        }

        return () => {
            // Ensure background scrolling is enabled when the modal is closed or unmounted
            document.body.style.overflow = "unset";
        };
    }, [name, openName]);

    useEffect(() => {
        if (!enableOutsideClick) return;

        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                close();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, [enableOutsideClick, close]);

    if (name !== openName) return null;

    return createPortal(
        <div className="fixed top-0 left-0 z-50 w-full h-full transition-all duration-500 bg-opacity-50 backdrop-blur">
            <div
                className="fixed  px-5 py-12 max-h-[80%] min-w-[30%] w-[80%] overflow-auto transition-all duration-500 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 rounded-lg shadow-lg lg:w-fit md:p-12 top-1/2 left-1/2 dark:bg-gray-900"
                ref={modalRef}
            >
                <button
                    onClick={close}
                    className="absolute p-1 transition-all duration-200 transform translate-x-2 bg-transparent border-none rounded-sm top-3 right-6 hover:bg-gray-200 dark:hover:bg-gray-800"
                >
                    <HiX className="text-3xl" />
                </button>

                <div>{cloneElement(children, { onCloseModal: close })}</div>
            </div>
        </div>,
        document.body
    );
}
Modal.Open = Open;
Modal.Window = Window;

export default Modal;
